/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ minuten: NonNullable<unknown> }} Planning_Rooster_DuurInputs */

const nl_planning_rooster_duur = /** @type {(inputs: Planning_Rooster_DuurInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.minuten} min`)
};

/**

* @param {Planning_Rooster_DuurInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const planning_rooster_duur = /** @type {((inputs: Planning_Rooster_DuurInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Planning_Rooster_DuurInputs, { locale?: "nl" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_planning_rooster_duur(inputs)
});
export { planning_rooster_duur as "planning.rooster.duur" }